export const DownloadPlotButtons = ({ onDownloadSvg, onDownloadPng }) => (
  <div class="download-buttons">
    <button
      class="btn btn-teal mr-4"
      title="Download windrose in Scaleable Vector Graphics format (recommended)"
      onClick={onDownloadSvg}
    >
      Download SVG
    </button>
    <button
      class="btn btn-teal"
      title="Download windrose as a PNG raster image"
      onClick={onDownloadPng}
    >
      Download PNG
    </button>
  </div>
);
